module.exports = __webpack_public_path__ + "media/images/badges/yogasix/inactive/Y6Warrior2022_Badges_5000_Inactive@1x-94ba28899fad643f88eb2d9a089b86c8.png";